import { FC, useContext, useMemo } from 'react';
import { Avatar, Stack } from '@mui/material';
import { ConnectWithoutContact } from '@mui/icons-material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { DialogContext } from '@cvt/contexts';
import { useDictionary } from '@cvt/hooks/useDictionary';

import { useMe } from '@modules/Auth/hooks/useMe';
import { PreferenceVersionSummary } from '@modules/Users/partials/PreferenceVersionSummary';
import { PreferenceCard } from '@modules/Users/components/PreferenceCard';


export const CurrentObjectives: FC = () => {

  const { openDialog } = useContext(DialogContext);
  const dictionary = useDictionary();

  const { user } = useMe();

  const objectives = useMemo(() => {
    const { preferences } = user || {};
    return [
      preferences?.communicationObjective1,
      preferences?.communicationObjective2,
      preferences?.communicationObjective3,
    ].filter(Boolean) as string[];
  }, [user]);

  return (
    <Stack gap={{ xs: 6, sm: 2 }}>
      <PreferenceCard
        title={dictionary.objectives.title}
        subtitle={dictionary.objectives.subtitle}
        onEdit={() => openDialog('editCommunicationObjectives', { user })}
        icon={
          <Avatar
            variant="rounded"
            sx={{ bgcolor: 'primary.main' }}
          >
            <ConnectWithoutContact sx={{ fontSize: 24 }}/>
          </Avatar>
        }
        items={objectives}
      />

      <ErrorBoundary message={dictionary.preferences.versionSummary.emptyHistory}>
        <PreferenceVersionSummary createdLabel={dictionary.objectives.createdLabel}/>
      </ErrorBoundary>
    </Stack>
  );
};